import React from 'react'
import PropTypes from 'prop-types'
import { isEmpty, prop } from 'ramda'
import Chip from './Chip'
import withStyle from './ChipList.style'

const ChipList = ({ className, chips, remove }) => (
  <>
    <div className={className}>
      {!isEmpty(chips) &&
        Object.values(chips).map((chip) => (
          <Chip key={prop('value', chip)} remove={remove} {...chip} />
        ))}
    </div>
  </>
)

export default withStyle(ChipList)

ChipList.propTypes = {
  chips: PropTypes.object,
  className: PropTypes.string,
  remove: PropTypes.func,
}
